export default function (props: any) {
    return (
        <svg width="58px" height="59px" viewBox="0 0 58 59" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-551.000000, -7896.000000)">
                    <g transform="translate(551.000000, 7896.900000)">
                        <rect x="0" y="0" width="58" height="58"></rect>
                        <circle stroke="#FFFFFF" fill="#FFFFFF" cx="29" cy="46.212715" r="1.89137698"></circle>
                        <line
                            x1="26.0711952"
                            y1="10.3116675"
                            x2="31.9288048"
                            y2="10.3116675"
                            stroke="#FFFFFF"
                            strokeWidth="1.7"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></line>
                        <rect stroke="#FFFFFF" strokeWidth="1.7" x="15.1" y="5.6" width="27.8" height="46.8" rx="5"></rect>
                    </g>
                </g>
            </g>
        </svg>
    );
}
